import { createStore } from 'vuex'

export default createStore({
  state: {
    // heic/heif (iPhone photos) are converted to jpg before upload, see utils/fileUpload.js
    allowedFiles: ['pdf', 'png', 'jpg', 'jpeg', 'heic', 'heif'],
    baseApiUrl: process.env.VUE_APP_API_URL || "https://alulaeme.com/api/",
    baseImageUrl: process.env.VUE_APP_IMAGE_URL || "https://alulaeme.com/storage/",
    basePdfUrl: process.env.VUE_APP_PDF_URL || "https://alulaeme.com/",

    // baseApiUrl:"https://alulaemde.manialab.sa/api/",
    // baseImageUrl:"https://alulaemde.manialab.sa/storage/",
    // basePdfUrl:"https://alulaemde.manialab.sa/",
    loader:0,
    showPopUp:0,
    apiStatus:false,
    popUpMessage:null,
    
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
